import React, { useState, useEffect } from 'react';
import { db } from '../config/firebaseConfig';
import { addDoc, collection, getDocs, doc, updateDoc } from 'firebase/firestore';
import { Button, Form, Alert, Card, Pagination, ListGroup } from 'react-bootstrap';

const YemekListesiEkle = () => {
  const [yemekAdi, setYemekAdi] = useState('');
  const [tarih, setTarih] = useState('');
  const [kategori, setKategori] = useState('');
  const [malzemeler, setMalzemeler] = useState([]);
  const [yeniMalzeme, setYeniMalzeme] = useState('');
  const [tarif, setTarif] = useState('');
  const [mesaj, setMesaj] = useState(null);
  const [hata, setHata] = useState(null);
  const [alisverisSepeti, setAlisverisSepeti] = useState([]);
  const [selectedMalzemeler, setSelectedMalzemeler] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5; // Number of items per page in the shopping cart

  // Fetch all unpurchased ingredients from Firebase
  const fetchAlisverisSepeti = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, 'yemekListesi'));
      const sepetMap = new Map();
  
      querySnapshot.forEach((docSnap) => {
        const meal = docSnap.data();
        meal.malzemeler.forEach((malzeme, index) => {
          if (!malzeme.satinAlindi) {
            const ad = malzeme.ad.trim().toLowerCase();
            // Eğer aynı ad varsa ilkini koru (veya isteğe göre topla)
            if (!sepetMap.has(ad)) {
              sepetMap.set(ad, {
                mealId: docSnap.id,
                malzemeIndex: index,
                ad: malzeme.ad, // Orijinal haliyle gösterelim
              });
            }
          }
        });
      });
  
      const benzersizSepet = Array.from(sepetMap.values());
  
      setAlisverisSepeti(benzersizSepet);
      setSelectedMalzemeler([]);
      setCurrentPage(1);
    } catch (error) {
      console.error('Alışveriş sepeti yüklenirken hata:', error);
      setHata('Alışveriş sepeti yüklenirken bir hata oluştu.');
    }
  };
  

  // Fetch data on component mount
  useEffect(() => {
    fetchAlisverisSepeti();
  }, []);

  // Handle adding ingredients (supports comma-separated input)
  const handleMalzemeEkle = (e) => {
    e.preventDefault();
    if (yeniMalzeme.trim()) {
      const yeniMalzemeler = yeniMalzeme
        .split(',')
        .map((item) => item.trim())
        .filter((item) => item)
        .map((item) => ({ ad: item, satinAlindi: false }));
      setMalzemeler([...malzemeler, ...yeniMalzemeler]);
      setYeniMalzeme('');
    }
  };

  // Delete an ingredient from the form
  const handleMalzemeSil = (index) => {
    setMalzemeler(malzemeler.filter((_, i) => i !== index));
  };

  // Handle selecting/deselecting ingredients
  const handleMalzemeSelect = (item) => {
    const key = `${item.mealId}-${item.malzemeIndex}`;
    if (selectedMalzemeler.includes(key)) {
      setSelectedMalzemeler(selectedMalzemeler.filter((id) => id !== key));
    } else {
      setSelectedMalzemeler([...selectedMalzemeler, key]);
    }
  };

  // Mark selected ingredients as purchased, update Firebase, and remove from frontend
  const handleAlisverisiTamamla = async () => {
    if (selectedMalzemeler.length === 0) {
      setHata('Lütfen en az bir malzeme seçin.');
      return;
    }

    try {
      // Group selected items by mealId to minimize Firebase updates
      const updatesByMeal = {};
      selectedMalzemeler.forEach((key) => {
        const [mealId, malzemeIndex] = key.split('-');
        if (!updatesByMeal[mealId]) {
          updatesByMeal[mealId] = [];
        }
        updatesByMeal[mealId].push(parseInt(malzemeIndex));
      });

      // Update each meal document in Firebase
      for (const mealId of Object.keys(updatesByMeal)) {
        const mealRef = doc(db, 'yemekListesi', mealId);
        const querySnapshot = await getDocs(collection(db, 'yemekListesi'));
        let mealData;
        querySnapshot.forEach((doc) => {
          if (doc.id === mealId) {
            mealData = doc.data();
          }
        });

        if (mealData) {
          const updatedMalzemeler = [...mealData.malzemeler];
          updatesByMeal[mealId].forEach((index) => {
            updatedMalzemeler[index] = {
              ...updatedMalzemeler[index],
              satinAlindi: true,
            };
          });
          await updateDoc(mealRef, { malzemeler: updatedMalzemeler });
        }
      }

      // Update frontend state by removing purchased items
      setAlisverisSepeti((prevSepet) =>
        prevSepet.filter(
          (item) => !selectedMalzemeler.includes(`${item.mealId}-${item.malzemeIndex}`)
        )
      );
      setSelectedMalzemeler([]); // Clear selected items
      setCurrentPage(1); // Reset to first page

      setMesaj('Seçilen malzemeler satın alındı olarak işaretlendi.');
      fetchAlisverisSepeti(); // Refresh from Firebase to ensure consistency
    } catch (error) {
      console.error('Alışveriş tamamlanırken hata:', error);
      setHata('Alışveriş tamamlanırken bir hata oluştu.');
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMesaj(null);
    setHata(null);

    if (!yemekAdi || !tarih || !kategori || malzemeler.length === 0 || !tarif) {
      setHata('Lütfen tüm alanları doldurun.');
      return;
    }

    try {
      await addDoc(collection(db, 'yemekListesi'), {
        yemekAdi,
        tarih,
        kategori,
        malzemeler: malzemeler.map((m) => ({ ad: m.ad, satinAlindi: m.satinAlindi })),
        tarif,
        createdAt: new Date(),
      });

      setMesaj('Yemek başarıyla eklendi!');
      setYemekAdi('');
      setTarih('');
      setKategori('');
      setMalzemeler([]);
      setTarif('');
      fetchAlisverisSepeti(); // Refresh the cart
    } catch (error) {
      console.error('Yemek eklenirken hata:', error);
      setHata('Yemek eklenirken bir hata oluştu.');
    }
  };

  // Pagination logic
  const totalPages = Math.ceil(alisverisSepeti.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedMalzemeler = alisverisSepeti.slice(startIndex, startIndex + itemsPerPage);

  // Handle page change
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <div className="yemek-listesi-ekle-container">
      <div className="row">
        {/* Left Side: Yemek Ekle Form */}
        <div className="col-md-6">
          <div className="yemek-listesi-ekle-section-title text-center mb-5">
            <h2>Yemek Ekle</h2>
            <div className="yemek-listesi-ekle-title-shape">
              <svg viewBox="0 0 200 20" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M 0,10 C 40,0 60,20 100,10 C 140,0 160,20 200,10"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                />
              </svg>
            </div>
            <p className="yemek-listesi-ekle-lead">
              Yeni bir yemek ekleyerek aylık planınızı oluşturun.
            </p>
          </div>

          <Card className="yemek-listesi-ekle-card shadow-sm">
            <Card.Body>
              {mesaj && <Alert variant="success">{mesaj}</Alert>}
              {hata && <Alert variant="danger">{hata}</Alert>}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="yemekAdi">
                  <Form.Label>Yemek Adı</Form.Label>
                  <Form.Control
                    type="text"
                    value={yemekAdi}
                    onChange={(e) => setYemekAdi(e.target.value)}
                    placeholder="Ör: Mercimek Çorbası"
                    aria-label="Yemek adı"
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="tarih">
                  <Form.Label>Tarih</Form.Label>
                  <Form.Control
                    type="date"
                    value={tarih}
                    onChange={(e) => setTarih(e.target.value)}
                    aria-label="Yemek tarihi"
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="kategori">
                  <Form.Label>Kategori</Form.Label>
                  <Form.Select
                    value={kategori}
                    onChange={(e) => setKategori(e.target.value)}
                    aria-label="Yemek kategorisi"
                    required
                  >
                    <option value="">Kategori Seçin</option>
                    <option value="Çorba">Çorba</option>
                    <option value="Ana Yemek">Ana Yemek</option>
                    <option value="Tatlı">Tatlı</option>
                    <option value="Salata">Salata</option>
                    <option value="Diğer">Diğer</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3" controlId="malzemeler">
                  <Form.Label>Alışveriş Listesi</Form.Label>
                  <div className="d-flex mb-2">
                    <Form.Control
                      type="text"
                      value={yeniMalzeme}
                      onChange={(e) => setYeniMalzeme(e.target.value)}
                      placeholder="Ör: domates,soğan,pırasa"
                      aria-label="Yeni malzeme"
                    />
                    <Button
                      variant="outline-success"
                      className="ms-2"
                      onClick={handleMalzemeEkle}
                      aria-label="Malzeme ekle"
                    >
                      Ekle
                    </Button>
                  </div>
                  {malzemeler.length > 0 && (
                    <ul className="yemek-listesi-ekle-malzeme-list list-group mb-2">
                      {malzemeler.map((malzeme, index) => (
                        <li
                          key={index}
                          className="list-group-item d-flex justify-content-between align-items-center"
                        >
                          <span className={malzeme.satinAlindi ? 'text-decoration-line-through text-muted' : ''}>
                            {malzeme.ad}
                          </span>
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => handleMalzemeSil(index)}
                            aria-label={`Sil ${malzeme.ad}`}
                          >
                            Sil
                          </Button>
                        </li>
                      ))}
                    </ul>
                  )}
                </Form.Group>

                <Form.Group className="mb-3" controlId="tarif">
                  <Form.Label>Tarif</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    value={tarif}
                    onChange={(e) => setTarif(e.target.value)}
                    placeholder="Yemeğin hazırlanış talimatlarını buraya yazın..."
                    aria-label="Yemek tarifi"
                    required
                  />
                </Form.Group>

                <div className="text-center">
                  <Button variant="success" type="submit" aria-label="Yemeği kaydet">
                    Yemeği Kaydet
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </div>

        {/* Right Side: Alışveriş Sepeti */}
        <div className="col-md-6">
          <div className="yemek-listesi-ekle-section-title text-center mb-5">
            <h2>Alışveriş Sepeti</h2>
            <div className="yemek-listesi-ekle-title-shape">
              <svg viewBox="0 0 200 20" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M 0,10 C 40,0 60,20 100,10 C 140,0 160,20 200,10"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                />
              </svg>
            </div>
            <p className="yemek-listesi-ekle-lead">
              Satın alınacak malzemeleri seçin ve tamamlayın.
            </p>
          </div>

          <Card className="yemek-listesi-ekle-card shadow-sm">
            <Card.Body>
              {alisverisSepeti.length === 0 ? (
                <Alert variant="info">Alışveriş sepeti boş.</Alert>
              ) : (
                <>
                  <ListGroup className="yemek-listesi-ekle-malzeme-list mb-3">
                    {paginatedMalzemeler.map((item, index) => (
                      <ListGroup.Item
                        key={`${item.mealId}-${item.malzemeIndex}`}
                        className="cart-item"
                      >
                        <div className="cart-item-content">
                          <Form.Check
                            type="checkbox"
                            id={`checkbox-${item.mealId}-${item.malzemeIndex}`}
                            checked={selectedMalzemeler.includes(`${item.mealId}-${item.malzemeIndex}`)}
                            onChange={() => handleMalzemeSelect(item)}
                            className="custom-checkbox"
                            label={<span className="visually-hidden">{`Seç ${item.ad}`}</span>}
                          />
                          <span className="cart-item-name">{item.ad}</span>
                        </div>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>

                  <div className="text-center mb-3">
                    <Button
                      variant="success"
                      onClick={handleAlisverisiTamamla}
                      disabled={selectedMalzemeler.length === 0}
                      aria-label="Alışverişi tamamla"
                      className="complete-shopping-btn"
                    >
                      Alışverişi Tamamla
                    </Button>
                  </div>

                  {/* Pagination Controls */}
                  {totalPages > 1 && (
                   <Pagination className="justify-content-center mt-4">
                   <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                   <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                 
                   {Array.from({ length: totalPages }, (_, i) => i + 1)
                     .filter((page) => {
                       return (
                         page === 1 || // always show first
                         page === totalPages || // always show last
                         (page >= currentPage - 1 && page <= currentPage + 1) // show current -1, current, current +1
                       );
                     })
                     .map((page, index, array) => {
                       const isPrevEllipsis = array[index - 1] && page - array[index - 1] > 1;
                       return (
                         <React.Fragment key={page}>
                           {isPrevEllipsis && <Pagination.Ellipsis disabled />}
                           <Pagination.Item
                             active={page === currentPage}
                             onClick={() => handlePageChange(page)}
                           >
                             {page}
                           </Pagination.Item>
                         </React.Fragment>
                       );
                     })}
                 
                   <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
                   <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
                 </Pagination>
                  )}
                </>
              )}
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default YemekListesiEkle;